import { Grid, Paper, CircularProgress, Box } from '@mui/material';
import { useState } from 'react';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useTranslation } from 'react-i18next';
import InstallCustomerForm from '../components/installCustomerForm';

// TODO: Översätt
export const SupportInstallCustomer = () => {
  const { t } = useTranslation();
  // const isMounted = useIsMounted();
  const [loading] = useState(false);
  return (
    <>
      <GridWrapper>
        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'row' }}>
          <MainContentHeader title='Ny uppsättning' />
        </Grid>
        <Grid item xs={12} lg={8}>
          <Paper sx={{ p: 3, overflow: 'hidden' }}>
            {loading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress role='alert' aria-busy='true' aria-label={t('common:statusMessages.loading')} />
              </Box>
            )}
            {!loading && (
              <GridWrapper>
                <Grid item xs={12}>
                  <InstallCustomerForm />
                </Grid>
              </GridWrapper>
            )}
          </Paper>
        </Grid>
      </GridWrapper>
    </>
  );
};
